import { render } from "./balances-doughnut-block.vue?vue&type=template&id=0044ce33&scoped=true"
import script from "./balances-doughnut-block.vue?vue&type=script&lang=js"
export * from "./balances-doughnut-block.vue?vue&type=script&lang=js"

import "./balances-doughnut-block.vue?vue&type=style&index=0&id=0044ce33&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0044ce33"]])

export default __exports__